import { Clock } from 'lucide-react';
import ProfileCardSlider from './ProfileCardSlider';
import LandingFrame from '../../assets/checker/landing-grid-bg.png';

export default function HeroSection() {
    return (
        <section className="min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-72px)] lg:min-h-0 lg:h-[calc(100vh-136px)] relative bg-[#ECECEC] mx-4 md:mx-6 lg:mx-10 my-4 md:my-6 lg:my-8 rounded-[16px] md:rounded-[20px] overflow-hidden flex items-center">
            {/* Full-height faded candidate-grid backdrop */}
            <div
                className="pointer-events-none select-none absolute inset-y-0 right-0 w-full lg:w-1/2 bg-no-repeat bg-cover bg-center opacity-70"
                style={{ backgroundImage: `url(${LandingFrame})` }}
                aria-hidden="true"
            />

            <div className="w-full flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-8 px-6 md:px-10 lg:pl-16 lg:pr-12 py-8 md:py-12 lg:py-0 relative z-10">
                {/* Left Content */}
                <div className="flex-shrink-0 w-full lg:max-w-[600px] text-center lg:text-left">
                    {/* Main Headline */}
                    <h1 className="mb-4 md:mb-6">
                        <div className="text-[#BDBDBD] text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight">
                            Real Checks.
                        </div>
                        <div className="text-gray-900 text-[36px] sm:text-[48px] md:text-[56px] lg:text-[72px] xl:text-[96px] font-bold leading-[1.15] tracking-tight">
                            Real Answers.
                        </div>
                    </h1>

                    {/* Description */}
                    <p className="text-gray-900 text-[13px] md:text-[14px] lg:text-[15px] leading-relaxed mb-4 md:mb-5 max-w-[500px] mx-auto lg:mx-0">
                        We put boots on the ground to build an intelligence report, gather evidence and protect you.
                    </p>

                    {/* Turnaround SLA — surfaced prominently so buyers know the timeline up front */}
                    <div className="mb-5 md:mb-6 inline-flex items-center gap-2 rounded-full bg-[#FF6B35]/10 px-4 py-2 text-[#FF6B35]">
                        <Clock className="w-4 h-4 shrink-0" />
                        <span className="text-sm md:text-base font-bold">
                            Your report, delivered in 21 working days
                        </span>
                    </div>

                    {/* Tagline */}
                    <div className="mb-6 md:mb-8 max-w-[540px] mx-auto lg:mx-0 border-l-4 border-[#FF6B35] pl-4 md:pl-5 text-left">
                        <p className="text-gray-900 text-base md:text-lg lg:text-xl font-medium leading-relaxed">
                            Every hire deserves a background check, and it's{' '}
                            <span className="font-bold text-[#FF6B35]">
                                absolutely essential for staff with access to your home, family, or finances.
                            </span>
                        </p>
                    </div>
                </div>

                {/* Right Content - Animated Profile Card over the faded candidate grid */}
                <div className="flex-1 w-full flex justify-center lg:justify-end">
                    <ProfileCardSlider />
                </div>
            </div>
        </section>
    );
}
